module.exports = "/assets/data/1f7ae0eb5127b070ef313a22f85a2f5b-KA19.data.json";